<template lang="html">
  <div>
    <b-row>
      <b-col md="12">
        <b-card>
          <div class="table-responsive-sm">
            <table class="table b-table table-striped">
                <thead class="" style="background-color:#f1f1f1">
                    <tr style="text-align:center">
                        <th class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">아이디</th>
                        <th class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">이름</th>
                        <th class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">생일</th>
                        <th class="" style="border-right:1px solid #a4b7c1; vertical-align:middle">성별</th>
                        <th class="" style="vertical-align:middle">가입일</th>
                    </tr>
                </thead>
                <tbody class="">
                    <!---->
                    <tr class="" style="background-color:#ffffff; border-bottom:1px solid #a3b6c0; text-align:center">
                        <td class="" style="border-right:1px solid #a4b7c1">{{userInfoItems.user_id}}</td>
                        <td class="" style="border-right:1px solid #a4b7c1">{{userInfoItems.user_name}}</td>
                        <td class="" style="border-right:1px solid #a4b7c1">{{userInfoItems.birthday}}</td>
                        <td class="" style="border-right:1px solid #a4b7c1">{{userInfoItems.gender_name}}</td>
                        <td class="">{{userInfoItems.reg_date}}</td>
                    </tr>
                </tbody>
            </table>
          </div>
        </b-card>
        <b-card>
          <b-row>
            <b-col sm="12">
              <div class="text-center modal_loadingbar" style="margin:220px 0 230px 0">
                <div style="width:200px; margin:0 auto; vertical-align:middle">
                  <b-spinner label="Large Spinner" style="vertical-align:middle"></b-spinner>
                  <span style="vertical-align:middle; padding:5px; font-weight:blod; font-size:20px">Loading...</span>
                </div>
              </div>
            </b-col>
            <b-col sm="12" class="modal_tabledisplay">
              <b-row>
                <b-col sm="2">
                  <span class="pr-"><strong>총 {{items.length}}건</strong></span>
                </b-col>
                <b-col sm="2"></b-col>
                <b-col sm="5"></b-col>
                <b-col md="3">
                  <b-form-group label-cols-sm="5" label="" class="mb-0">
                    <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="12" class="pt-sm-1 modal_tabledisplay">
              <b-row>
                <b-col sm="1"></b-col>
                <b-col sm="12">
                  <b-table
                    striped
                    hover
                    :fields="fieldItems"
                    :items="items"
                    :busy="items == 0"
                    :current-page="currentPage"
                    :per-page="perPage"
                    >
                    <div slot="table-busy" class="text-center my-2">
                      <strong>데이터가 없습니다.</strong>
                    </div>
                    <template slot="browser" slot-scope="data">
                      <div>{{data.item.browser.split("|")[0]}}<br/>ver : {{data.item.browser.split("|")[1]}}</div>
                    </template>
                    <template slot="HEAD_sta_reg_date" slot-scope="data">
                      <div v-show="contentStatUserInfoOptions.view_type == 'VIEW'">조회 시간</div>
                      <div v-show="contentStatUserInfoOptions.view_type == 'DOWNLOAD'">다운로드 시간</div>
                      <div v-show="contentStatUserInfoOptions.view_type == 'RATING'">평점 시간</div>
                    </template>
                  </b-table>
                </b-col>
              </b-row>
            </b-col>
            <b-col sm="12" class="pt-sm-1 modal_tabledisplay">
              <b-row class="pb-sm-2">
                <b-col sm="1"></b-col>
                <b-col sm="12" class="my-1">
                  <b-pagination
                    v-model="currentPage"
                    :total-rows="listRows"
                    :per-page="perPage"
                    align="center"
                  ></b-pagination>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
export default {
  props: {
    contentStatUserInfoOptions: {
    },
    contentStatUserFormModal: null,
  },
  data(){
    return {
      userQueryParams: {},
      userInfoItems: {},
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 30, 50, 100],
      fieldItems: [{
        'rnum': {
          'label': '번호',
          'class': 'text-center',
          'tdStyle': 'user-vmiddle',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'sta_reg_date': {
          'label': '조회 시간',
          'class': 'text-center',
          'tdClass': 'user-vmiddle',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'connection_ip': {
          'label': 'IP',
          'class': 'text-center',
          'tdClass': 'user-vmiddle',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'network_path': {
          'label': '접속경로',
          'class': 'text-center',
          'tdClass': 'user-vmiddle',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'keyword_type_name': {
          'label': '메인경로',
          'class': 'text-center',
          'tdClass': 'user-vmiddle',
          'thStyle': {
             'vertical-align': 'middle',
             'text-align': 'center'
          }
        }
      }, {
        'keyword': {
          'label': '검색어',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'device_type': {
          'label': '이용기기 종류',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'device': {
          'label': '이용기기',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }, {
        'browser': {
          'label': '사용 브라우저',
          'class': 'text-center',
          'thStyle': {
             'vertical-align': 'middle'
          }
        }
      }],
      items: [],
    }
  },
  computed: {
    listRows() {
      return this.items.length
    }
  },
  mounted: function() {
    $(".modal_loadingbar").hide();
    $(".modal_tabledisplay").show();
    var self = this;
  },
  watch: {
    contentStatUserFormModal (newVal, oldVal) {
      var self = this;
      if(newVal){
        self.findUserInfoList();
      }
    },
  },
  methods:{
    // 메소드명 : findUserInfoList()
    // ### 유저 검색 조회 ###
    // 유저를 T_DR_USER DB테이블에서 조회한다.
    //
    // 최초작성 : 2019.09.16
    // 파라미터 :
    //  - Object => userQueryParams(user_id,user_name)
    // *************************
    // ## 코드 히스토리 ##
    //    날짜     작성자   수정내용
    // 2019.09.16  황경현   최초작성
    // *************************
    findUserInfoList() {
      $(".modal_loadingbar").show();
      $(".modal_tabledisplay").hide();

      var self = this;
      var token = sessionStorage.getItem("myToken");
      var param = encodeURI(JSON.stringify(self.contentStatUserInfoOptions));
      var data = new FormData();
      data.append('objs', param);

      self.$http.post('/api/select/drRecordUserInfoList?access_token=' + token, data, null)
      .then((result) => {
        self.userInfoItems = result.data.userInfoData;
        self.items = result.data.userRecordList;
        var itemCnt = self.items.length;
        self.items.forEach(function (el, idx, arr){
          el.rnum = itemCnt - (idx);
        });
        $(".modal_loadingbar").hide();
        $(".modal_tabledisplay").show();
      })
    },
  },
}
</script>


<style scoped>
.user-vmiddle {vertical-align: middle;}
</style>



// WEBPACK FOOTER //
// src/views/statistics/content/ContentStatUserInfoModal.vue